module.exports = __webpack_public_path__ + "img/arrow_right_outline_grey.75dc559b.png";